<template>
  <layout-main-inner title="内容管理">
    <layout-card-wrap hasHeaderSlot>
      <template slot="title">
        <el-button
          slot="action"
          type="primary"
          size="small"
          @click="create">新增内容</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column label="内容标题">
          <template slot-scope="{row}">
            <link-route :link-to="`/wxapp-message-detail?msgId=${row.msgId}&vendorId=${row.vendorId}`">
              {{ row.title }}
            </link-route>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="首图"
          width="220">
          <template slot-scope="scope">
            <el-image
              style="width: 200px; height: 120px"
              :src="scope.row.image"
              fit="cover"></el-image>
          </template>
        </el-table-column> -->
        <el-table-column
          label="内容类型"
          width="100">
          <template slot-scope="{row}">
            <span v-if="row.contentType === 0">多图</span>
            <span v-if="row.contentType === 1">公众号链接</span>
            <!-- <span v-if="row.contentType === 3">商品链接</span> -->
          </template>
        </el-table-column>
        <el-table-column
          label="内容说明"
          prop="name"></el-table-column>
        <el-table-column
          label="最近发布时间"
          width="140">
          <template slot-scope="{row}">
            <span>{{ row.pubTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="浏览次数"
          width="80"
          prop="viewCount"></el-table-column>
        <el-table-column
          label="状态"
          width="80">
          <template slot-scope="{row}">
            <span>{{ row.status | statusFormat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="{row}">
            <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.status !== 2"
                  @click.native="deleteRow(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  @click.native="update(row)">编辑</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'WxappMessageIndex',
  components: {},
  filters: {
    statusFormat(value) {
      const status = {
        0: '草稿',
        1: '未发布',
        2: '已发布'
      }
      return status[value]
    }
  },
  props: {},
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.config.vendorId = this.userInfo.orgId
    this.fetchList()
  },
  methods: {
    update(row) {
      this.$router.push(`/wxapp-message-edit?msgId=${row.msgId}&vendorId=${row.vendorId}`)
    },
    create() {
      this.$router.push('/wxapp-message-edit?vendorId=' + this.userInfo.orgId)
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('portal/getmessages', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteRow(row) {
      this.$confirm('您确定删除该条内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('portal/deletemessage', {
            payload: {
              vendorId: row.vendorId,
              msgId: row.msgId
            },
            success: (res) => {
              console.log(res)
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  }
}
</script>
